import React, { useEffect, useState } from "react";
import styles from "./non-academic-activity.module.css";
import { Typography } from "antd";
import CustomTable from "../../../../../../common/custom-table/custom-table";
import { fetchStudentNonAcademicActivities } from "../../../../../../services/student";
import { formatDate } from "../../../../../../utils/format-date/format-date";

const NonAcademicActivity = ({ studentID }) => {
  const [loading, setLoading] = useState(false);
  const [activityList, setActivityList] = useState([]);

  useEffect(() => {
    studentID && getStudentNonAcademicActivity();
  }, [studentID]);

  const getStudentNonAcademicActivity = async () => {
    try {
      setLoading(true);
      const response = await fetchStudentNonAcademicActivities(studentID);
      if (response?.data) {
        setActivityList(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const columns = [
    {
      title: "Activity Name",
      dataIndex: "activity_name",
      key: "activity_name",
      render: (_, record) => record?.activity?.name ?? "-",
    },
    {
      title: "Club Name",
      dataIndex: "club_name",
      key: "club_name",
      render: (_, record) => record?.activity?.name ?? "-",
    },
    {
      title: "House Name",
      dataIndex: "house_name",
      key: "house_name",
      render: (_, record) => record?.student?.student_house?.name ?? "-",
    },
    { title: "Medal", dataIndex: "medals", key: "medals" },
    {
      title: "Trainer",
      dataIndex: "trainer",
      key: "trainer",
      render: (_, record) => record?.activity?.teacher?.full_name ?? "-",
    },
    {
      title: "Member Since",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => (value ? formatDate(value) : "-"),
    },
  ];
  return (
    <div className={styles.container}>
      <Typography className={styles.title}>Attached with</Typography>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={activityList}
          total={activityList?.length}
          collapsible={false}
          pagination={false}
          loading={loading}
          showTotalText={false}
        />
      </div>
    </div>
  );
};

export default NonAcademicActivity;
